@if (inMenu) {
<!-- A full-width menu row: icon, visible label, current language at the end -->
<label class="flex items-center gap-3 w-full min-h-11 px-3 rounded-xl cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800">
   <i class="mdi mdi-web text-xl leading-none text-slate-500 dark:text-slate-400" aria-hidden="true"></i>
   <span class="flex-1">{{ 'components.language.label' | translate }}</span>
   <select id="language-picker" class="max-w-[9rem] bg-transparent appearance-none cursor-pointer text-end outline-none text-cyan-600 dark:text-cyan-300 dark:[&>option]:bg-slate-900"
      (change)="changeLanguage($event)">
      @for (language of languageService.languages; track language.code) {
         <option [value]="language.code" [selected]="language.code === languageService.current" [attr.lang]="language.code">
            {{ language.name }}
         </option>
      }
   </select>
   <i class="mdi mdi-chevron-right text-slate-400 -ms-2" aria-hidden="true"></i>
</label>
} @else {
<!-- The globe sits inside the pill, so it reads as part of the one control -->
<label class="relative inline-flex items-center">
   <span class="sr-only">{{ 'components.language.label' | translate }}</span>
   <i class="mdi mdi-web absolute start-3 pointer-events-none text-cyan-600 dark:text-cyan-300" aria-hidden="true"></i>
   <select id="language-picker" class="glass-select h-10 !ps-8 !pe-4 !py-0 !tracking-normal !text-cyan-600 dark:!text-cyan-300" [attr.aria-label]="'components.language.label' | translate"
      (change)="changeLanguage($event)">
      @for (language of languageService.languages; track language.code) {
         <option [value]="language.code" [selected]="language.code === languageService.current" [attr.lang]="language.code">
            {{ language.name }}
         </option>
      }
   </select>
</label>
}
